import React from 'react';
import { Icon } from '@global-ecom/nitro-uds/elements';
import Head from 'next/head';

import { useTranslate } from 'hooks/useTranslations';
import { useProductListFilterContext } from 'ui/components/ProductListFilterProvider';
import { ProductListClearAllFilters } from 'ui/components/ProductListClearAllFilters';
import { splitThreadExecution } from 'utils/splitThreadExecution';

export const ProductListActiveFilters: React.FC = () => {
  const { enabledFilterOptions, removeFilterValue } =
    useProductListFilterContext();

  const t = useTranslate();

  return Object.keys(enabledFilterOptions).length > 0 ? (
    <ul
      className="flex flex-wrap mt-5 items-center"
      role="menu"
      aria-label={t('selectedFilters')}
    >
      {enabledFilterOptions && (
        <Head>
          <meta name="robots" content="noindex, follow" />
        </Head>
      )}
      {Object.keys(enabledFilterOptions).map(filterKey => (
        <FilterOptionValues
          key={`${filterKey}`}
          filter={enabledFilterOptions[filterKey]}
          onClick={(filter, value) => {
            splitThreadExecution({
              mainCallback: () => {
                removeFilterValue(filter, value);
              },
            })();
          }}
        />
      ))}
      <li role="none" className="pr-2 py-1">
        <ProductListClearAllFilters role="menuitem" />
      </li>
    </ul>
  ) : null;
};

const FilterOptionValues = ({ filter, onClick }) =>
  filter.values.map(v => (
    <li key={`${filter.id}-${v.value}`} role="none" className="pr-2 py-1">
      <ChipIcon
        onClick={onClick}
        id={filter.id}
        label={filter.label}
        value={v.label}
      />
    </li>
  ));

const ChipIcon = ({ id, label, value, onClick }) => {
  const t = useTranslate();

  const handleClick = () => {
    onClick(id, value);
  };

  return (
    <button
      onClick={handleClick}
      data-test-id="selected-filter-item"
      role="menuitem"
      className="relative h-8 pr-7 pl-2 bg-puma-black-700 text-puma-black text-sm font-bold tracking-wide leading-tight flex items-center flex-0 focus:outline-none focus:ring-2 ring-puma-gold"
      type="button"
    >
      <span className="sr-only">{t('clickToClear')}</span>
      <span>
        {label}: {value}
      </span>
      <span
        className="absolute mt-px mr-0.5 right-1 top-1/2 -translate-y-1/2"
        aria-hidden="true"
      >
        <Icon name="close" size="xl" />
      </span>
    </button>
  );
};
